module.exports = __webpack_public_path__ + "assets/collaboration_black.46e51502.svg";